import { useParams, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ProductModule from "./ProductModule";
import { getProductBySlug, PRODUCTS } from "./products";



export default function ProductPage() {
  const { t } = useTranslation();
  const { slug } = useParams();
  const product = getProductBySlug(slug);

  if (!product) {
    const available = Object.keys(PRODUCTS);
    return (
      <div style={{ maxWidth: "var(--maxw)", margin: "60px auto", padding: "0 16px" }}>
        <h2 style={{ color: "var(--text-color)" }}>{t("productPage.notFound.title", "Producto no encontrado")}</h2>
        <p style={{ color: "var(--text-light)" }}>
          {t("productPage.notFound.message", { slug, defaultValue: `El artículo “${slug}” no existe en el catálogo.` })}
        </p>
        <p style={{ color: "var(--text-light)" }}>
          {t("productPage.notFound.availableSlugs", "Slugs disponibles:")}{" "}
          {available.map((s) => (
            <code key={s} style={{ marginRight: 8 }}>{s}</code>
          ))}
        </p>
        <Link to="/catalogo" style={{ color: "var(--secondary-color)" }}>
          {t("productPage.backToCatalog", "← Ir al catálogo")}
        </Link>
      </div>
    );
  }

  return <ProductModule product={product} />;
}
